<script>
import * as echarts from 'echarts'

export default {
  name: 'dailyActiveUserView',
  data() {
    return {
      loading: false,
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dtRange: [],
      chart: null,
      chart2: null,
      resizeHandler: null,
      startDt: null,
      endDt: null
    }
  },
  computed: {
    dates() {
      return (this.list || []).map(i => i.dt)
    },
    dauSeries() {
      return (this.list.dau || []).map(i => this.toNumber(i.dau))
    },
    loginPvSeries() {
      return (this.list || []).map(i => this.toNumber(i.loginPv))
    },
    diff1Series() {
      return (this.list || []).map(i => this.toNumber(i.diff1d))
    },
    ratio1Series() {
      return (this.list || []).map(i => this.toPercent(i.ratio1d))
    }
  },
  mounted() {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 14);
    this.dtRange[0] = this.formatDate(start)
    this.dtRange[1] = this.formatDate(end)
    this.getData()
    this.resizeHandler = () => {
      if (this.chart) this.chart.resize()
      if (this.chart2) this.chart2.resize()
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (this.chart2) {
      this.chart2.dispose()
      this.chart2 = null
    }
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      let month = date.getMonth() + 1; // 月份从0开始，要+1
      let day = date.getDate();

      // 补零：小于10前面加0
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;

      return `${year}-${month}-${day}`;
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    search() {
      this.currentPage = 1
      this.getData()
    },
    toNumber(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    toPercent(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return 0
      return n * 100
    },
    fmtPercent(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return (n * 100).toFixed(2) + '%'
    },
    ratioColor(v) {
      const n = Number(v)
      if (!Number.isFinite(n) || n === 0) return '#909399'
      return n > 0 ? '#67c23a' : '#f56c6c'
    },

    async getData() {
      this.startDt = this.dtRange[0]
      this.endDt = this.dtRange[1]


      this.loading = true
      this.$axios.get("/hadoop/dau", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          startDt: this.startDt,
          endDt: this.endDt
        }
      }).then((res) => {
        this.total = res.data.data.total
        this.list = res.data.data.records
        this.loading = false
        this.$nextTick(() => this.renderCharts())
      }).catch(() => {
        this.loading = false
      })
    },

    renderCharts() {
      this.renderMainChart()
      this.renderDiffChart()
    },

    renderMainChart() {
      const el = this.$refs.mainChart
      if (!el) return

      if (!this.chart) {
        this.chart = echarts.init(el)
      }

      const option = {
        title: {
          text: 'DAU / 登录PV 趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          top: 50,
          data: ['DAU', '登录PV']
        },
        grid: {
          left: 40,
          right: 30,
          top: 80,
          bottom: 40
        },
        xAxis: {
          type: 'category',
          data: this.dates,
          axisLabel: {
            rotate: 35
          }
        },
        yAxis: [
          {
            type: 'value',
            name: 'DAU'
          },
          {
            type: 'value',
            name: '登录PV'
          }
        ],
        series: [
          {
            name: 'DAU',
            type: 'line',
            smooth: true,
            data: this.dauSeries,
            emphasis: {focus: 'series'}
          },
          {
            name: '登录PV',
            type: 'bar',
            yAxisIndex: 1,
            data: this.loginPvSeries,
            emphasis: {focus: 'series'}
          }
        ]
      }

      this.chart.setOption(option, true)
    },

    renderDiffChart() {
      const el = this.$refs.diffChart
      if (!el) return

      if (!this.chart2) {
        this.chart2 = echarts.init(el)
      }

      const option = {
        title: {
          text: '环比(较前一日)变化：差值 / 比率',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          valueFormatter: (v) => v
        },
        legend: {
          top: 50,
          data: ['差值(diff_1d)', '比率(ratio_1d%)']
        },
        grid: {
          left: 40,
          right: 30,
          top: 80,
          bottom: 40
        },
        xAxis: {
          type: 'category',
          data: this.dates,
          axisLabel: {
            rotate: 35
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '差值'
          },
          {
            type: 'value',
            name: '比率(%)'
          }
        ],
        series: [
          {
            name: '差值',
            type: 'bar',
            data: this.diff1Series
          },
          {
            name: '比率',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            data: this.ratio1Series
          }
        ]
      }

      this.chart2.setOption(option, true)
    }
  }
}
</script>

<template>
  <div class="wrap">
    <div class="toolbar">
      <div class="title">日活跃用户（DAU）</div>
      <div class="actions">
        <el-form :inline="true">
          <el-form-item label="日期范围">
            <el-date-picker
              v-model="dtRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              :start-placeholder="dtRange[0]"
              :end-placeholder="dtRange[1]"

            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-row :gutter="16" class="mb16">
      <el-col :span="6">
        <div class="card">
          <div class="card-title">最新DAU（登录用户数）</div>
          <div class="card-value">{{ list ? list[0].dau : '-' }}</div>
          <div class="card-sub">日期：{{ list[0] ? list[0].dt : '-' }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="card-title">最新登录PV（总登录次数）</div>
          <div class="card-value">{{ list[0] ? list[0].loginPv : '-' }}</div>
          <div class="card-sub">日期：{{ list[0] ? list[0].dt : '-' }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="card-title">较前一日差值</div>
          <div class="card-value" :style="{color: ratioColor(list[0] ? list[0].diff1d : 0)}">
            {{ list[0] ? list[0].diff1d : '-' }}
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card">
          <div class="card-title">较前一日比率</div>
          <div class="card-value" :style="{color: ratioColor(list[0] ? list[0].ratio1d : 0)}">
            {{ list[0] ? fmtPercent(list[0].ratio1d) : '-' }}
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="charts">
      <div class="chart" ref="mainChart"/>
      <div class="chart" ref="diffChart"/>
    </div>

    <el-table
      :data="list"
      size="mini"
      border
      stripe
      v-loading="loading"
      element-loading-text="加载中..."
      class="mt16"
    >
      <el-table-column prop="dt" label="日期" width="110"/>
      <el-table-column prop="dau" label="DAU" width="90"/>
      <el-table-column prop="loginPv" label="登录PV" width="100"/>
      <el-table-column prop="diff1d" label="较前一天差值" width="100">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.diff1d)}">{{ scope.row.diff1d }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="diff2d" label="较前二天差值" width="100">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.diff2d)}">{{ scope.row.diff2d }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="diff3d" label="较前三天差值" width="100">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.diff3d)}">{{ scope.row.diff3d }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="diff4d" label="较前四天差值" width="100">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.diff4d)}">{{ scope.row.diff4d }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="diff5d" label="较前五天差值" width="100">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.diff5d)}">{{ scope.row.diff5d }}</span>
        </template>
      </el-table-column>
      <el-table-column label="较前一天比率" width="110">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.ratio1d)}">{{ fmtPercent(scope.row.ratio1d) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="较前二天比率" width="110">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.ratio2d)}">{{ fmtPercent(scope.row.ratio2d) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="较前三天比率" width="110">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.ratio3d)}">{{ fmtPercent(scope.row.ratio3d) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="较前四天比率" width="110">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.ratio4d)}">{{ fmtPercent(scope.row.ratio4d) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="较前五天比率" width="110">
        <template slot-scope="scope">
          <span :style="{color: ratioColor(scope.row.ratio5d)}">{{ fmtPercent(scope.row.ratio5d) }}</span>
        </template>
      </el-table-column>
    </el-table>


    <el-footer class="el-footer">
      <el-pagination
        id="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5,10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="11"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-footer>
  </div>

</template>

<style scoped>
.wrap {
  padding: 16px;
}

.toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  line-height: 32px;
}

.actions {
  display: flex;
  align-items: center;
}

.mb16 {
  margin-bottom: 16px;
}

.mt16 {
  margin-top: 16px;
}

.card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 14px 14px 12px;
  min-height: 86px;
}

.card-title {
  font-size: 12px;
  color: #909399;
}

.card-value {
  margin-top: 6px;
  font-size: 22px;
  font-weight: 700;
  color: #303133;
}

.card-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.charts {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.chart {
  height: 500px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/dailyActiveUserView.vue